// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import * as uuid from "uuid/v4";
export default class CourseSectionSchedulerBreakService {
    static createSchedulerBreak() {
        // Return defaults
        return {
            id: uuid(),
            name: "",
            monday: false,
            tuesday: false,
            wednesday: false,
            thursday: false,
            friday: false,
            saturday: false,
            sunday: false,
            endTimeHours24: 0,
            endTimeMinutes24: 0,
            startTimeHours24: 0,
            startTimeMinutes24: 0,
        };
    }
    static getWeekDisplayString(brk) {
        let displayString = "";
        if (brk.sunday) {
            displayString += "Su";
        }
        if (brk.monday) {
            displayString += "M";
        }
        if (brk.tuesday) {
            displayString += "T";
        }
        if (brk.wednesday) {
            displayString += "W";
        }
        if (brk.thursday) {
            displayString += "Th";
        }
        if (brk.friday) {
            displayString += "F";
        }
        if (brk.saturday) {
            displayString += "Sa";
        }
        return displayString;
    }
    static getTimeDisplayString(hours, minutes) {
        const isAm = hours < 12;
        const hour = hours % 12 || 12;
        const minuteString = minutes < 10 ? "0" + minutes : minutes.toString();
        return `${hour}:${minuteString} ${isAm ? "AM" : "PM"}`;
    }
    static getSchedulable(brk) {
        return {
            startDate: null,
            endDate: null,
            elms: [brk],
        };
    }
    static getSchedulableTrail(brk) {
        return {
            id: brk.id,
            type: "Break",
            child: CourseSectionSchedulerBreakService.getSchedulable(brk),
        };
    }
    static validate(brk) {
        const requiredFields = {
            id: "Id",
            name: "Name",
            startTimeHours24: "Start Time Hours",
            startTimeMinutes24: "Start Time Minutes",
            endTimeHours24: "End Time Hours",
            endTimeMinutes24: "Start Time Minutes",
        };
        for (const key of Object.keys(requiredFields)) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CourseSectionSchedulerBreak'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CourseSectionSchedulerBreak'.
            if (brk[key] == null || brk[key] === "") {
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly id: "Id"; readonly name: "Name"; readonly startTimeHours24: "Start Time Hours"; readonly startTimeMinutes24: "Start Time Minutes"; readonly endTimeHours24: "End Time Hours"; readonly endTimeMinutes24: "Start Time Minutes"; }'.
                return { valid: false, message: requiredFields[key] + " is required" };
            }
        }
        if (brk.startTimeHours24 + brk.startTimeMinutes24 / 60 >
            brk.endTimeHours24 + brk.endTimeMinutes24 / 60) {
            return {
                valid: false,
                message: "End time must be later than start time",
            };
        }
        return { valid: true, message: null };
    }
    static getBlockFromSchedulerBreak(section, content) {
        const days = new Set();
        if (section.sunday) {
            days.add("sun");
        }
        if (section.monday) {
            days.add("mon");
        }
        if (section.tuesday) {
            days.add("tues");
        }
        if (section.wednesday) {
            days.add("wed");
        }
        if (section.thursday) {
            days.add("thur");
        }
        if (section.friday) {
            days.add("fri");
        }
        if (section.saturday) {
            days.add("sat");
        }
        return {
            startTime24: section.startTimeHours24 + section.startTimeMinutes24 / 60,
            endTime24: section.endTimeHours24 + section.endTimeMinutes24 / 60,
            // @ts-expect-error - TS2322 - Type 'Node' is not assignable to type 'ReactNode'.
            content,
            days,
        };
    }
}
